import * as Yup from "yup";

export const subscriptionSchema = Yup.object().shape({
  plans: Yup.array().of(
    Yup.object().shape({
      trialDays: Yup.number()
        .integer("Value must be an integer")
        .required("Trial days are required")
        .min(0, "Trial days cannot be negative")
        .typeError("Invalid days"),
      freeListing: Yup.number()
        .integer("Value must be an integer")
        .required("Free listings are required")
        .min(0, "Free listings cannot be negative")
        .typeError("Invalid value"),
      additionalListing: Yup.number()
        .integer("Value must be an integer")
        .required("Additional listings are required")
        .min(0, "Additional listings cannot be negative")
        .typeError("Invalid value"),
      amount: Yup.number()
        .required("Amount is required")
        .min(0, "Amount cannot be negative")
        .typeError("Invalid amount"),
    })
  ),
});
